import {
  Card,
  Description,
  Details,
  Image,
  Title,
} from "../../CommonStyles/Card";

const CertificationCard = ({ certification, setOpenModalCertification }) => {
  return (
    <Card
      onClick={() =>
        setOpenModalCertification({ state: true, certification: certification })
      }
    >
      <Image src={certification.image} />
      <Details>
        <Title>{certification.title}</Title>
        <Description>{certification.description}</Description>
      </Details>
    </Card>
  );
};

export default CertificationCard;
